/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Loadable from 'react-loadable';
import Spinner from '@atlaskit/spinner';
var spinnerContainer = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%'
});
var ElementBrowserLoader = Loadable({
  loader: function loader() {
    return import( /* webpackChunkName: "@atlaskit-internal_editor-element-browser" */'../ElementBrowser').then(function (module) {
      return module.default;
    });
  },
  loading: function loading() {
    return jsx("div", {
      css: spinnerContainer
    }, jsx(Spinner, {
      size: "medium",
      interactionName: "element-browser-spinner"
    }));
  }
});
export default ElementBrowserLoader;